import './StationStatus.css';

import { observer } from "mobx-react-lite";

import { StationsLiveStore } from "../model/StationsLiveStore";

type Props = {
    /** shortcode станции в AzuraCast: deep / dnb / house */
    shortcode: string | null | undefined;
};

const HeadphonesIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
        <path d="M4 14v-2a8 8 0 0 1 16 0v2" />
        <path d="M4 14a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2Z" fill="currentColor" stroke="none" />
        <path d="M20 14a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2 2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2Z" fill="currentColor" stroke="none" />
    </svg>
);

/**
 * Статус эфира (on/off) и число слушателей поверх кубика станции.
 * Ничего не рендерит, пока нет данных — без сдвигов вёрстки.
 */
export const StationStatus = observer(({ shortcode }: Props) => {
    const store = StationsLiveStore.getShared();
    const data = store.get(shortcode);

    if (!data) return null;

    return (
        <div className={`station-status ${data.online ? 'is-on' : 'is-off'}`}>
            <span className="station-status__state">
                <span className="station-status__dot" />
                {data.online ? 'on' : 'off'}
            </span>
            <span className="station-status__listeners">
                <HeadphonesIcon />
                {data.listeners}
            </span>
        </div>
    );
});
